import { IconType } from 'react-icons';
import { Link, useLocation } from 'react-router';

import { Box, Flex, FlexProps, Icon } from '@chakra-ui/react';

interface NavItemProps extends FlexProps {
  icon?: IconType;
  children: React.ReactNode;
  to: string;
  notificationCount?: number;
  onClick?: () => void;
}

const SidebarItem = ({
  icon,
  children,
  to,
  notificationCount,
  onClick,
  ...rest
}: NavItemProps) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);

  if (onClick) {
    return (
      <Box onClick={onClick} style={{ textDecoration: 'none' }}>
        <Flex
          align="center"
          p={{ base: '4', md: '4' }}
          mx={{ base: '3', md: '4' }}
          mb="1"
          borderRadius="lg"
          role="group"
          cursor="pointer"
          minH={{ base: '48px', md: 'auto' }}
          transition="all 0.2s"
          _hover={{
            bg: 'teal',
            color: 'white',
            transform: 'translateY(-1px)',
            boxShadow: 'md',
          }}
          _active={{
            transform: 'translateY(0)',
            boxShadow: 'sm',
          }}
          bg={isActive ? 'teal' : 'inherit'}
          color={isActive ? 'white' : 'inherit'}
          {...rest}
        >
          {icon && (
            <Icon
              mr="4"
              fontSize={{ base: '22', md: '20' }}
              _groupHover={{
                color: 'white',
              }}
              as={icon}
            />
          )}
          <Box
            flex="1"
            fontSize={{ base: 'md', md: 'md', '2xl': 'lg' }}
            fontWeight={{ base: 'medium', md: 'normal' }}
          >
            {children}
          </Box>
          {notificationCount !== undefined && notificationCount > 0 && (
            <Box
              ml={2}
              px={2}
              py={1}
              fontSize="xs"
              fontWeight="bold"
              lineHeight="none"
              color="white"
              bg="red.500"
              rounded="full"
              minW="20px"
              textAlign="center"
            >
              {notificationCount}
            </Box>
          )}
        </Flex>
      </Box>
    );
  }

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Flex
        align="center"
        p={{ base: '4', md: '3', '2xl': '4' }}
        mx={{ base: '3', md: '4' }}
        mb="1"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        minH={{ base: '48px', md: 'auto' }}
        transition="all 0.2s"
        _hover={{
          bg: 'teal',
          color: 'white',
          transform: 'translateY(-1px)',
          boxShadow: 'md',
        }}
        _active={{
          transform: 'translateY(0)',
          boxShadow: 'sm',
        }}
        bg={isActive ? 'teal' : 'inherit'}
        color={isActive ? 'white' : 'inherit'}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize={{ base: '22', md: '20' }}
            _groupHover={{
              color: 'white',
            }}
            as={icon}
          />
        )}
        <Box
          fontSize={{ base: 'md', md: 'md', '2xl': 'lg' }}
          fontWeight={{ base: 'medium', md: 'normal' }}
        >
          {children}
        </Box>
        {notificationCount !== undefined && notificationCount > 0 && (
          <Box
            ml="1"
            bg="red.500"
            color="white"
            borderRadius="full"
            px={2}
            fontSize="sm"
            fontWeight="bold"
          >
            {notificationCount}
          </Box>
        )}
      </Flex>
    </Link>
  );
};

export default SidebarItem;
